const trMessages = {
  dropdowns: {
      nodata: 'iÇERİK BULUNAMADI',
      clear: 'temizle',
      comboArrowBtnAriaLabelExpand: 'birleşik kutuyu genişlet',
      comboArrowBtnAriaLabelCollapse: 'birleşik kutuyu daralt',
      dropDownListArrowBtnAriaLabel: 'seç'
  }
};

export default trMessages;